module.exports = __webpack_public_path__ + "static/media/cross-white.72209e2e.svg";